/**
 * 填报表单字段类型，对应后端 STORE_ORM_TYPE
 */
export const FORM_TYPE_LIST = [
  { value: 1, name: '普通文本' },
  { value: 2, name: '多行文本' },
  { value: 3, name: '电话带区号' },
  { value: 4, name: '数字文本' },
  { value: 5, name: '身份证' },
  { value: 6, name: '单选' },
  { value: 7, name: '多选' },
  { value: 8, name: '时间预约' },
]

/** 单选 / 多选：content 存 { list: [{ name, value }] } */
export const FORM_OPTION_TYPES = [6, 7]

/**
 * 时间预约：content 存
 * { weekDays: [0..6], startTime: 'HH:mm', endTime: 'HH:mm', interval: 分钟 }
 * weekDays 表示可预约的星期，取值同 JS getDay()：1=周一 … 6=周六、0=周日
 * interval 是 startTime ~ endTime 之间生成时段的间隔，单位分钟
 */
export const FORM_DATE_TYPE = 8

/** 时间预约默认间隔（分钟） */
export const DEFAULT_INTERVAL = 30

/** 周一 ~ 周日，1=周一 0=周日 */
export const FORM_WEEK_LIST = [
  { value: 1, name: '周一' },
  { value: 2, name: '周二' },
  { value: 3, name: '周三' },
  { value: 4, name: '周四' },
  { value: 5, name: '周五' },
  { value: 6, name: '周六' },
  { value: 0, name: '周日' },
]

export function getFormTypeName(type) {
  let item = FORM_TYPE_LIST.find((item) => item.value == type)
  return item ? item.name : '未知类型'
}

/** 用 == 比较，兼容后端把 tinyint 传成字符串的情况 */
export function isOptionType(type) {
  return FORM_OPTION_TYPES.some((item) => item == type)
}
